import { ContentWrapper, HeaderContent } from '@/shared/ui'
import { Flex } from 'antd'

import { MyWaveForm } from './ui/MyWaveForm'
import { RadioForm } from './ui/RadioForm'

export function MyWavePage() {
  return (
    <>
      <HeaderContent
        title="Моя Чистая Волна"
        description="Раздел позволяет редактировать настройки Моей Чистой Волны"
      />
      <ContentWrapper>
        <Flex vertical gap={16}>
          <MyWaveForm />
          <RadioForm />
        </Flex>
      </ContentWrapper>
    </>
  )
}
